import React from "react";
import styled from "styled-components";
import { $greyBorder } from "../../../assets/colors";

const Container = styled.div`
  padding: 15px;
  border-left: 3.5px solid ${$greyBorder};
`;

export const SlotPrefsContainer: React.FunctionComponent<{
  style?: React.CSSProperties;
}> = ({ children, style }) => <Container style={style}>{children}</Container>;
